let registered = false;

export function registerPrologLanguage(monaco) {
  if (registered) return;
  registered = true;

  monaco.languages.register({ id: 'prolog' });

  monaco.languages.setMonarchTokensProvider('prolog', {
    defaultToken: '',
    tokenPostfix: '.prolog',

    tokenizer: {
      root: [
        // Line comments
        [/%.*$/, 'comment'],

        // Block comments  /* ... */
        [/\/\*/, { token: 'comment', next: '@blockComment' }],

        // Clause neck  :-
        [/:-/, 'neck'],

        // Variables: uppercase or _ prefix
        [/[_A-Z][A-Za-z0-9_]*/, 'variable'],

        // Integers
        [/[0-9]+/, 'number'],

        // Single-quoted atoms
        [/'/, { token: 'string.quote', next: '@string' }],

        // Cut
        [/!/, 'cut'],

        // Multi-char operators first to avoid partial matches
        [/=:=/, 'operator'],
        [/=\\=/, 'operator'],
        [/\\=/, 'operator'],
        [/\\\+/, 'operator'],
        [/=</, 'operator'],
        [/>=/, 'operator'],

        // Clause terminator: . followed by whitespace or end of line
        [/\.(?=\s|$)/, 'clause-end'],

        // Arithmetic / comparison operators
        [/[+\-*\/<>=]/, 'operator'],

        // Delimiters
        [/,/, 'comma'],
        [/;/, 'semicolon'],
        [/\|/, 'pipe'],

        // Brackets
        [/[[\]()]/, 'bracket'],

        // Atoms — 'is' and 'not' singled out as keywords
        [/[a-z][A-Za-z0-9_]*/, { cases: { is: 'keyword', not: 'keyword', '@default': 'atom' } }],

        [/\s+/, ''],
      ],

      blockComment: [
        [/[^*]+/, 'comment'],
        [/\*\//, { token: 'comment', next: '@pop' }],
        [/\*/, 'comment'],
      ],

      string: [
        [/[^']+/, 'string'],
        [/''/, 'string.escape'],        // '' is an escaped quote inside a quoted atom
        [/'/, { token: 'string.quote', next: '@pop' }],
      ],
    },
  });

  monaco.editor.defineTheme('prolog-dark', {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'comment.prolog',       foreground: '6a9955', fontStyle: 'italic' },
      { token: 'variable.prolog',      foreground: '9cdcfe' },
      { token: 'number.prolog',        foreground: 'b5cea8' },
      { token: 'atom.prolog',          foreground: 'dcdcaa' },
      { token: 'keyword.prolog',       foreground: '569cd6', fontStyle: 'bold' },
      { token: 'neck.prolog',          foreground: '569cd6' },
      { token: 'cut.prolog',           foreground: 'c586c0', fontStyle: 'bold' },
      { token: 'operator.prolog',      foreground: 'd4d4d4' },
      { token: 'clause-end.prolog',    foreground: '569cd6' },
      { token: 'bracket.prolog',       foreground: 'ffd700' },
      { token: 'comma.prolog',         foreground: '808080' },
      { token: 'semicolon.prolog',     foreground: 'c586c0' },
      { token: 'pipe.prolog',          foreground: '569cd6' },
      { token: 'string.prolog',        foreground: 'ce9178' },
      { token: 'string.quote.prolog',  foreground: 'ce9178' },
      { token: 'string.escape.prolog', foreground: 'ce9178' },
    ],
    colors: {
      'editor.background': '#1e1e1e',
    },
  });

  // Light-mode counterpart — same token roles, VS Light-style hues.
  // Mirrors prolog-dark: each colour is the same hue family brightened/darkened
  // to maintain equivalent contrast on a light (#f8f8f8) background.
  monaco.editor.defineTheme('prolog-light', {
    base: 'vs',
    inherit: true,
    rules: [
      { token: 'comment.prolog',       foreground: '498c49', fontStyle: 'italic' },
      { token: 'variable.prolog',      foreground: '0070c1' },  // #9cdcfe → darker blue
      { token: 'number.prolog',        foreground: '4a8c5c' },  // #b5cea8 → darker sage
      { token: 'atom.prolog',          foreground: '7a6800' },  // #dcdcaa → dark gold
      { token: 'keyword.prolog',       foreground: '0451a5', fontStyle: 'bold' },
      { token: 'neck.prolog',          foreground: '0451a5' },
      { token: 'cut.prolog',           foreground: '9b348e', fontStyle: 'bold' },  // #c586c0 → darker
      { token: 'operator.prolog',      foreground: '3a3a3a' },  // #d4d4d4 → near-black
      { token: 'clause-end.prolog',    foreground: '0451a5' },
      { token: 'bracket.prolog',       foreground: '8f6000' },  // #ffd700 → dark amber
      { token: 'comma.prolog',         foreground: '808080' },
      { token: 'semicolon.prolog',     foreground: '9b348e' },
      { token: 'pipe.prolog',          foreground: '0451a5' },
      { token: 'string.prolog',        foreground: 'a1260d' },  // #ce9178 → darker terracotta
      { token: 'string.quote.prolog',  foreground: 'a1260d' },
      { token: 'string.escape.prolog', foreground: 'a1260d' },
    ],
    colors: {
      'editor.background': '#f8f8f8',
    },
  });
}
